module.exports = __webpack_public_path__ + "img/icon_map_loc_tree_select.d5e7287a.svg";